import { useContext } from "react";
import ContractsContext from "../../../context/ContractsContext/ContractsContext";
import styles from "../Contracts.module.css";
import { useHistory } from "react-router-dom";

const MenuList = (props: any) => {
  const history = useHistory();
  const { dispatch } = useContext(ContractsContext);
  console.log("props: ", props);
  const returnRenew = (idCollaborator: any) => {
    localStorage.currentModule = "Colaboradores";
    localStorage.currentPill = 1;
    localStorage.nextStep = 2;
    localStorage.lastSection = "contracts";
    history.push(`/collaborators/${idCollaborator}/1`, { from: "/contracts" });
  };
  return (
    <>
      <button
        className={styles.botonrRegresar}
        onClick={() => returnRenew(props?.idCollaborator)}
      >
        <p>Renovar</p>
      </button>
    </>
  );
};

export default MenuList;
